import { ErrorHandler, Injectable, inject } from '@angular/core';
import { AppUpdateService } from '../services/app-update/app-update.service';
import { isChunkLoadError } from '../utils/chunk-load-error.util';

@Injectable()
export class AppUpdateErrorHandler implements ErrorHandler {
  private readonly appUpdateService = inject(AppUpdateService);

  handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      this.appUpdateService.markUpdateAvailable();
    }
    console.error(error);
  }
}
